/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { investorDeclarationPostRequestSchema } from './investorDeclarationPostRequestSchema.ts';
import { investorDeclarationPostResponseSchema } from './investorDeclarationPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postInvestorDeclaration200Schema = z.lazy(() => investorDeclarationPostResponseSchema);

/**
 * @description 505 response
 */
export const postInvestorDeclaration505Schema = z.any();

export const postInvestorDeclarationMutationRequestSchema = z.lazy(() => investorDeclarationPostRequestSchema);

export const postInvestorDeclarationMutationResponseSchema = z.lazy(() => postInvestorDeclaration200Schema);
